import * as models from './invoicesModels';
// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.
// Use @typeName and isActionType for type detection that works even after serialization/deserialization.

interface SetInvoices { type: 'SET_INVOICES'; data: models.ApiInvoiceObject[]; }
interface SetLoading { type: 'SET_LOADING_INVOICES'; data: boolean; }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction =
    SetInvoices | SetLoading
    ;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const invoicesActionCreators = {
    setInvoices: (data: models.ApiInvoiceObject[]) => <SetInvoices> { type: 'SET_INVOICES', data: data },
    setLoading: (data: boolean) => <SetLoading> { type: 'SET_LOADING_INVOICES', data: data } 

};


// WEBPACK FOOTER //
// ./src/data/invoices/invoicesAction.ts